import React from "react";
import CompanyLogo from "@/assets/Logo_xl.avif";

export default function Footer() {
  return (
    <footer className="py-2 flex items-center justify-center gap-2 flex-shrink-0">
      <p className="text-xs text-slate-700">Powered by </p>
      <img
        src={CompanyLogo}
        alt="Logo HSEQ"
        width={100}
        loading="lazy"
        className="opacity-80 pointer-events-none"
      />
    </footer>
  );
}
